// extracted by mini-css-extract-plugin
export default {"back-button":"_7+l+pYrg8DlGGkiua-QOfA=="};